import { Col, Container, Row } from "reactstrap";
import { Cancelled, CancelledOrder, ECommerce, NewOrder, Processing, RecentOrdersTitle, Shipped, ShippedOrder } from "../../../../constants";
import OrdersCard from "./OrdersCard";
import OrderHistoryTable from "./OrderHistoryTable";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component displays the recent orders, including new orders, shipped orders, and cancelled orders. It also includes a table of order history.
const OrderHistoryContainer = () => {
  
  return (
    <>
      <Breadcrumbs mainTitle={RecentOrdersTitle} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <OrdersCard title={NewOrder} btn={Processing} color={"primary"} />
            <OrdersCard title={ShippedOrder} btn={Shipped} color={"success"} />
            <OrdersCard title={CancelledOrder} btn={Cancelled} color={"danger"} />
          </Col>
          <OrderHistoryTable />
        </Row>
      </Container>
    </>
  );
};

export default OrderHistoryContainer;